(function () {

    'use strict';

    angular.module('iplusjs.validator.isEqualTo', [
        'lodash',
        'iplusjs.utils.misc'
    ])
    .directive('iplusjsIsEqualTo', isEqualTo);

    isEqualTo.$inject = [
        '$log',
        'lodash',
        'MiscUtilsService'
    ];
    function isEqualTo($log, _, MiscUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, $attrs, $ngModel) {
                var showCaseSensitiveError = $scope.$eval($attrs.iietShowCaseSensitiveError),
                    ignoreEmptyValue = $scope.$eval($attrs.iietIgnoreEmptyValue),
                    compareVal;

                ignoreEmptyValue = _.isNil(ignoreEmptyValue) ? true : ignoreEmptyValue;

                $scope.$watch($attrs.iplusjsIsEqualTo, function (value) {
                    compareVal = MiscUtilsService.getValueCustomObject(value);

                    $ngModel.$validate();
                });

                function isEqualToValidator(value) {
                    var val = MiscUtilsService.getValueCustomObject(value);

                    if ((MiscUtilsService.isEmpty(val) && ignoreEmptyValue) || _.isNil(compareVal)) {
                        return true;
                    }
                    if (showCaseSensitiveError) {
                        if (MiscUtilsService.isEqual(val, compareVal, true) && val !== compareVal) {
                            $ngModel.$setValidity('isEqualToWrongCase', false);
                            return true;
                        } else {
                            $ngModel.$setValidity('isEqualToWrongCase', true);
                        }
                    }

                    return MiscUtilsService.isEqual(val, compareVal);
                }

                $ngModel.$validators.isEqualTo = isEqualToValidator;
            }
        };
    }
})();
